export default __webpack_public_path__ + "static/media/news9.759d2f1f.PNG";